// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2eR4C","content":"LoadingAlert_content__SAFAW"};